import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FahrerListView } from './list-view/fahrer.list-view';

export const fahrerFieldOk: FieldOkConfig = {
  name: 'fahrer',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrerListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};

export const fahrerMultiselectFieldOk: FieldOkConfig = {
  name: 'fahrer',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrerListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};

export const fahrerQueryFieldOk: FieldOkConfig = {
  name: 'fahrer',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FahrerListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};
